import React, { useState, useEffect, useRef } from 'react'

import classes from './PopupMentionLegales.module.css'
import Popup from '@/components/shared/Popup/Popup';
import PopupsManager from 'react-sdk/PopupsManager';
import { POPUPS } from '@/js/AppState';
import clsx from 'clsx';
import Texts from 'react-sdk/Texts';
import SoundPlayer from 'react-sdk/SoundPlayer';
import WaveSection from '@/components/shared/WaveSection/WaveSection';
import logo from "../../../images/logo.png";

const PopupMentionLegales = () => {
  useEffect(() => {
  

  }, []);


  const onClose = () => {
    PopupsManager.close(POPUPS.MENTION_LEGALES)
  }


  return (
    <Popup className={clsx(classes.PopupMentionLegales)} onClose={() => onClose()}>

      <img className={classes.logo} src={logo} />

      <WaveSection globalClasses={classes.WaveSection} contentClasses={classes.content} color="#fff">
          <div className={classes.text_ctnr} >
            <div className={classes.text} dangerouslySetInnerHTML={{ __html: Texts.get("mentions-legales-text") }} />
          </div>
      </WaveSection>
    </Popup>
  );
};



export default PopupMentionLegales;
